import React, { FC, useEffect, useRef, useState } from 'react'

import { cn } from '../../../../../lib/utils'

interface TabsProps {
  type: 'registrar' | 'rider'
  tabs: { [tab: string]: { value: string; disabled?: boolean } }
  activeTab: string
  setActiveTab: (tab: string) => void
  color: string
  loading: boolean
}

export const CustomTabs: FC<TabsProps> = ({
  type,
  tabs,
  setActiveTab,
  activeTab,
  color,
  loading,
}) => {
  const containerRef = useRef<HTMLDivElement | null>(null)
  const [indicator, setIndicator] = useState({ left: 0, width: 0 })

  const moveIndicatorTo = (tab: HTMLButtonElement | null) => {
    const container = containerRef.current

    if (!tab || !container) return
    const tabRect = tab.getBoundingClientRect()
    const containerRect = container.getBoundingClientRect()

    const left = tabRect.left - containerRect.left + container.scrollLeft
    setIndicator({ left, width: tabRect.width })
  }

  useEffect(() => {
    if (!loading) {
      const selector: HTMLButtonElement | null = document.querySelector(
        `.custom-tab.active-${type}`
      )
      moveIndicatorTo(selector)
    }
  }, [loading, activeTab, type])

  return (
    <div className="relative">
      <div
        ref={containerRef}
        className="flex items-center mt-6 border-b border-b-black/10 overflow-auto"
      >
        {Object.values(tabs).map((tab) => (
          <button
            disabled={tab.disabled || loading}
            key={tab.value}
            type="button"
            className={cn(
              `custom-tab relative w-[80px] min-w-fit p-2 capitalize whitespace-nowrap disabled:opacity-50`,
              activeTab === tab.value ? `active-${type}` : 'hover:opacity-70'
            )}
            style={{
              color: activeTab === tab.value ? color : '#000000',
            }}
            onClick={(e) => {
              setActiveTab(tab.value)
              moveIndicatorTo(e.currentTarget)
            }}
          >
            {tab.value}
          </button>
        ))}
      </div>
      <span
        style={{
          left: indicator.left,
          width: indicator.width,
          backgroundColor: color,
        }}
        className={cn(`absolute z-10 bottom-0 left-0 w-full h-[1px] transition-all duration-300`)}
      />
    </div>
  )
}
